import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { AUAContainer } from '../AUA';
import { connect } from 'react-redux';
import { T } from '../traks';
import { R } from '../routes';
import store from '../store';
import { PremiumHeader } from '../c/Premium/PremiumHeader';
import { PremiumCard } from '../c/Premium/PremiumCard';
import { nonPremiumDetails, premiumDetails } from '../c/Premium/PremiumDetails';
import { PremiumPlans } from '../c/Premium/PremiumPlans';
import { plans } from '../c/Premium/PremiumPlansData';
import { PremiumGuide } from '../c/Premium/PremiumGuide';
import { PremiumParticipants } from '../c/Premium/PremiumParticipants';
import { PremiumInfo } from '../c/Premium/PremiumInfo';
import { site_name } from '../Site';

function PremiumInner(props) {
    const [subscription, setSubscription] = useState(props.me && props.me.Subscription ? props.me.Subscription : 'free');

    const subscriptions = {
        free: <T>Not Premium</T>,
        pro: <T>Premium</T>
    }

    useEffect(() => {
        if (props.cart && props.cart.completed) {
            setSubscription('pro');
        }
    }, [props.cart])

    const goToGames = () => {
        R.goto_url('games');
    }

    const goToNewGame = () => {
        R.goto_url('new_game');
    }

    const triggerPremiumCart = () => {
        store.dispatch_value('show_cart', true);
    }

	const faqLink = <T>https://undervisning.aktiedysten.dk/faq-premium/</T>

    return (
        <Row>
            <PremiumHeader />
            <Container>
                <Row className="py-4 mt-1 premium-status">
                    <Col>
                        <div className="d-flex justify-content-between">
                            <div>
                                <h3><T>Your status:</T> <span className={subscription === 'free' ? 'not-premium-red' : 'premium-green'}>{subscriptions[subscription]}</span></h3>
                            </div>
                            <div className="d-flex justify-content-right">
                                <Row>
                                    <Button onClick={goToGames} className="ml-auto mb-auto mr-2 px-4 py-2"><T>Go to games</T></Button>
                                    <Button onClick={triggerPremiumCart} className="ml-auto mb-auto ad_new_game_button px-4 py-2"><T>Upgrade</T></Button>
                                </Row>
                            </div>
                        </div>
                    </Col>
                </Row>

                <Row className='mt-4 premium-container'>
                    <Col sm="6">
                        <PremiumCard
                            headerTitle={<T>Try {site_name} for free</T>}
                            headerIconSrc='<svg class="premium-card-icon" viewBox="0 0 24 24" data-id="icon-rocket-solid"><path d="M20 22L16.14 20.45C16.84 18.92 17.34 17.34 17.65 15.73L20 22M7.86 20.45L4 22L6.35 15.73C6.66 17.34 7.16 18.92 7.86 20.45M12 2C12 2 17 4 17 12C17 15.1 16.25 17.75 15.33 19.83C15 20.55 14.29 21 13.5 21H10.5C9.71 21 9 20.55 8.67 19.83C7.76 17.75 7 15.1 7 12C7 4 12 2 12 2M12 12C13.1 12 14 11.1 14 10C14 8.9 13.1 8 12 8C10.9 8 10 8.9 10 10C10 11.1 10.9 12 12 12Z"></path></svg>'
                            detailsIconSrc='<svg viewBox="0 0 24 24" data-id="icon-check-bold-solid"><path d="M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z"></path></svg>'
                            isPremiumCard={false}
                            details={nonPremiumDetails}
                            btnVars={{ btnText: <T>Start free game</T>, onClick: goToNewGame }}
                        />
                    </Col>
                    <Col sm="6">
                        <PremiumCard
                            headerTitle={<T>Premium from 6kr. per participant</T>}
                            headerIconSrc='<svg class="premium-card-icon" viewBox="0 0 24 24" data-id="icon-rocket-launch-solid"><path d="M13.13 22.19L11.5 18.36C13.07 17.78 14.54 17 15.9 16.09L13.13 22.19M5.64 12.5L1.81 10.87L7.91 8.1C7 9.46 6.22 10.93 5.64 12.5M21.61 2.39C21.61 2.39 16.66 .269 11 5.93C8.81 8.12 7.5 10.53 6.65 12.64C6.37 13.39 6.56 14.21 7.11 14.77L9.24 16.89C9.79 17.45 10.61 17.63 11.36 17.35C13.5 16.53 15.88 15.19 18.07 13C23.73 7.34 21.61 2.39 21.61 2.39M14.54 9.46C13.76 8.68 13.76 7.41 14.54 6.63S16.59 5.85 17.37 6.63C18.14 7.41 18.15 8.68 17.37 9.46C16.59 10.24 15.32 10.24 14.54 9.46M8.88 16.53L7.47 15.12L8.88 16.53M6.24 22L9.88 18.36C9.54 18.27 9.21 18.12 8.91 17.91L4.83 22H6.24M2 22H3.41L8.18 17.24L6.76 15.83L2 20.59V22M2 19.17L6.09 15.09C5.88 14.79 5.73 14.47 5.64 14.12L2 17.76V19.17Z"></path></svg>'
                            detailsIconSrc='<svg viewBox="0 0 24 24" data-id="icon-check-bold-solid"><path d="M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z"></path></svg>'
                            isPremiumCard={true}
                            details={premiumDetails}
                            btnVars={{ btnText: <T>Upgrade to premium</T>, onClick: triggerPremiumCart } }
                        />
                    </Col>
                    
                    <PremiumGuide />
                        <PremiumPlans 
                            onClick = {triggerPremiumCart}
                            plans = {plans}
                        />
                </Row>

                <Row className='premium-container mt-4'>
                    <PremiumParticipants {...props} />
                </Row>

                <Row className='premium-container mt-4'>
                    <PremiumInfo />
                </Row>

                <Row className='my-5'>
                    <Col className='d-flex'>
                         <a className="mx-auto mb-auto mr-2 px-5 py-3 premium-rounded-corners ad_btn_purple btn btn-secondary" target='_blank' href={props.render_static(faqLink)}><T>FAQ</T></a> 
                    </Col>
                </Row>
            </Container>
        </Row>
	);
}

const Premium = connect(
    (state) => ({
        cart: state.show_cart_game_upgrade
    })
)((props) => <AUAContainer><PremiumInner {...props}/></AUAContainer>);

export default Premium;


// WEBPACK FOOTER //
// ./src/p/Premium.js